import { NavigationGroup } from "./navigation-item.model";

export const VENDOR_NAVIGATION_ITEMS: NavigationGroup[] = [
  {
    items: [
      { title: 'nav.items.dashboard', icon: 'bi bi-house', link: '/' },
      // { title: 'nav.items.reports', icon: 'bi bi-file-earmark-text', link: '/reports' }
    ]
  },
  {
    groupTitle: 'nav.groups.products',
    items: [
      // { title: 'nav.items.add_product', icon: 'bi bi-plus-circle', link: '/products/new' },
      { title: 'nav.items.products', icon: 'bi bi-box', link: '/products' },
      { title: 'nav.items.reviews', icon: 'bi bi-plus-circle', link: '/reviews' }
    ]
  },
  {
    groupTitle: 'nav.groups.orders',
    items: [
      { title: 'nav.items.orders', icon: 'bi bi-box2', link: '/orders' }
    ]
  },
  {
    groupTitle: 'nav.groups.more',
    items: [
      { title: 'nav.items.settings', icon: 'bi bi-gear', link: '/settings' },
      { title: 'nav.items.wallet', icon: 'bi bi-wallet2', link: '/wallet' },
      { title: 'nav.items.users', icon: 'bi bi-people', link: '/users' }
    ]
  },
  {
    groupTitle: 'nav.groups.contact_us',
    items: [
      { title: 'nav.items.about_us', icon: 'bi bi-info-circle', link: '/about-us' },
      { title: 'nav.items.terms', icon: 'bi bi-book', link: '/terms-and-conditions' },
      { title: 'nav.items.privacy', icon: 'bi bi-file-earmark-lock', link: '/privacy-policy' }
    ]
  },
  {
    items: [
      { title: 'nav.items.logout', icon: 'bi bi-box-arrow-right', link: '/login' }
    ]
  }
];
